import axios from 'axios';
import Layout from '../shared/Layout';
import { useContext, useEffect, useRef, useState } from 'react';
import DetailsContext from '../../providers/DetailsContext';
import language from '../../variables/language';
import { useLocation, Link ,useNavigate, useParams  } from 'react-router-dom';
import Header from '../shared/Header';
import Form from '../../components/forms/Form';
import ModalClient from '../klienci/ModalClient';
import PipeContainer from './PipeContainer';
import ModalPipeline from './ModalPipeline';

import FunctionalHeader from '../../components/func panel/FunctionalHeader';
import Function from '../../components/func panel/Function';
import IconAdd from '../../components/icons/IconAdd';
import Selector from '../../components/forms/Selector';
import IconArrow from '../../components/icons/IconSend';
import IconAddPerson from '../../components/icons/IconAddPerson';
import IconSchema from '../../components/icons/IconSchema';
import IconClear from '../../components/icons/IconClear';
const DEFAULT_STAGE_TYPE = 3842;
const Pipeline = () => {
  const label = 'clients';
  const location = useLocation();
   const { id } = useParams();
   const navigate = useNavigate();
  const url = '/api/stages';
  const urlStages = '/api/stages'
  const urlClients = '/api/clients';
  const [modalState ,setModalState] = useState('none');
  const [refresh, setRefresh] = useState(0);
  const [toUpdateId , setToUpdateId] = useState('');
  const [client , setClient] = useState('');
  const [stageType, setStageType] = useState(id || DEFAULT_STAGE_TYPE);
  const [conversationId, setcConversationId] = useState();
  const [searchInput , setSearchInput] = useState('');
  const [nameFilter, setNameFilter] = useState('');
  const urlFinal = url + '?stageType=' + stageType;
  const urlConversationsProgress = '/api/conversationprogress/client';

    const [headerHeight , setHeaderHeight] = useState(0);
    const elementRef2 = useRef(null);
   const [lisRefresh, setLisRefresh] = useState(0);
   const [refreshContainer, setRefreshContainer] = useState(0);
  const [headerContainer , setHeaderContainer] = useState(0);

  const [headers, setHeaders] = useState(
    {'firstName':{}, 'lastName':{}, 'email':{},'tel':{},'product':{},'stage':{},'price':{},'icons':{
      'icon-delete':{'name':'icon-delete','type' : 'icon','url':url,'value' : '','mode':'delete'},
      'icon-card':{'name':'icon-card','type' : 'icon','url':url,'value' : '','mode':'card'},
      'icon-edit':{'name':'icon-edit','type' : 'icon','url':url,'value' : '','mode':'edit'},
    }}
    );
  const [inputs, setInputs] = useState(
    {
        'firstName':{'name':'firstName','type' : 'text','tagtype' : 'input','value' : '','disabled':false,'width':'49%'},
        'lastName':{'name':'lastName','type' : 'text','tagtype' : 'input','value' : '','disabled':false,'width':'49%'},
        'email':{'name':'email','type' : 'text','tagtype' : 'input','value' : '','disabled':false,'width':'49%'},
        'tel':{'name':'tel','type' : 'text','tagtype' : 'input','value' : '','disabled':false,'width':'49%'}
    });
  const [selectors, setSelectors] = useState({
    });
  const [inputsToUpdate, setInputsToUpdate] = useState(
    {
      'firstName':{'name':'firstName','type' : 'text','value' : ''},
       'lastName':{'name':'lastName','type' : 'text','value' : ''},
       'email':{'name':'email','type' : 'text','value' : ''},
       'tel':{'name':'tel','type' : 'number','value' : ''},
       'price':{'name':'price','type' : 'number','value' : ''},
       'dLastContact':{'name':'dLastContact','type' : 'date','value' : ''},
      //  'probability':{'name':'probability','type' : 'number','value' : ''},
    });
  const [selectorsToUpdate, setSelectorsToUpdate] = useState({
        'responsibleId':{'name':'responsibleId','type' : 'number','url':'/api/users','value' : ''},
       // 'project':{'name':'project','type' : 'number','url':'/api/projects','value' : ''},
        'stage':{'name':'stage','type' : 'number','url':urlFinal,'value' : ''},
      //  'language':{'name':'language','type' : 'number','url':'/api/languages','value' : ''},
        // 'category':{'name':'category','type' : 'number','url':'/api/categories','value' : ''},
    });
    const stateHundler = (state, id, client) => {
      if(state === 'edit'){
        setModalState('edit');
        setToUpdateId(id);
      }else if(state === 'none'){
        setModalState('none');
      }else if(state === 'menu'){
        setModalState('menu');
        setToUpdateId(id);
        setClient(client);
      }
    }
    const onRefreshHundler = ()=> {
      if(refresh==="1"){
        setRefresh('0');
      }else{
        setRefresh('1');
      }
      
    }
    const stopHund = (e) => {
      e.stopPropagation();
      console.log("sdsd");
    }


   const onListRefreshHundler = ()=> {
     if(lisRefresh==="1"){
      setLisRefresh('0');
     }else{
      setLisRefresh('1');
     }
     if(modalState !== 'menu'){
      onRefreshHundler();
     }

   }
   const onClientCreatedHundler = (newClient) => {
     if(!newClient || !newClient.id) {
       return;
     }
     axios.get(url+'?stageType='+stageType, { withCredentials: true })
       .then(response => {
         const firstStage = Array.isArray(response.data) && response.data[0];
         if(!firstStage) {
           return;
         }
         axios.put(urlClients+'/'+newClient.id,
           JSON.stringify({stage: firstStage.id}), {
             withCredentials: true,
             headers: { 'Content-Type': 'application/json' },
         }).then(() => {
           onRefreshHundler();
         }).catch(err => console.log(err));
       })
       .catch(err => console.log(err));
   }
      const handleStageTypeChange = (value) => {
        setStageType(value || DEFAULT_STAGE_TYPE);
      }
      const handleConversationChange = (value) => {
        setcConversationId(value || undefined);
      }
      const onClearFiltersHundler = () => {
        setStageType(DEFAULT_STAGE_TYPE);
        setcConversationId();
        setNameFilter('');
      }

        useEffect(()=>{
        if(headerHeight=== 2 &&  elementRef2.current){
          setHeaderContainer( elementRef2.current.offsetHeight +48);
        }else{
          setHeaderContainer('fit-content');
        }

      },[headerHeight,refreshContainer,lisRefresh]);

  return (
    <Layout>
      <FunctionalHeader height={headerContainer}  name={language[language.lang]["pipeline"]} >

            <div className='pipe-filters-bar'>
              <div className='flex-from-input-wraper pipe-filter-input' data-label={language[language.lang].firstName}>
                <input className='submit-field from-input txt-c' type='text'
                placeholder={language[language.lang].placeholderSearch}
                value={nameFilter} onChange={(e) => setNameFilter(e.target.value)} />
              </div>
              <div className='flex-from-input-wraper pipe-filter-select' data-label={language[language.lang].stageType}>
                <Selector name='stageType' url='/api/stage-types' value={stageType} disabled={false}
                selectorsHundler={handleStageTypeChange} className='submit-field form-selection txt-c' />
              </div>
              <div className='flex-from-input-wraper pipe-filter-select' data-label={language[language.lang].conversation}>
                <Selector name='conversation' url='/api/conversations/stagetype' value={conversationId} disabled={false}
                selectorsHundler={handleConversationChange} className='submit-field form-selection txt-c' />
              </div>
              <div className='pipe-filters-clear' onClick={onClearFiltersHundler} title={language[language.lang].find}>
                <IconClear fillColor='search-icon' />
              </div>
            </div>

            <Function num={2} icon={<IconAddPerson fillColor={'search-icon'}/>} heightHundler={setHeaderHeight}  headerHeight={headerHeight} >
              <div key={2}  ref={elementRef2} className='pipe-add-client-panel' >
                <h4 className='pipe-add-client-title'>{language[language.lang].modals[label].createTitle}</h4>
                <Form   inputs={inputs}  url={urlClients} onRefreshHundler={onListRefreshHundler}
                doneFunction={onClientCreatedHundler}
                name={language[language.lang].modals[label].createTitle}></Form>
              </div>
            </Function>
            <Function num={3} icon={<IconSchema fillColor={'search-icon'}   onClick={(e) => { e.stopPropagation();
                                                                        navigate("/pipeline-creator/"+stageType);
                                                                      }}/>}
              heightHundler={setHeaderHeight}  headerHeight={headerHeight} >
            </Function>

      </FunctionalHeader>
    {/* <Header name={language[language.lang][(location.pathname.replace("/",""))]}   opened='300px' >
      <Form inputs={inputs} selectors={selectors} url={url} onRefreshHundler={onRefreshHundler} name={language[language.lang].modals[label].createTitle}></Form>
    </Header> */}
    <main className='main-block'  >
      <div className='main-content txt-c' style={{overflowY:'visible'}} >
        <PipeContainer stateHundler={stateHundler} url={urlFinal} conversationId={conversationId} refresh={refresh} onRefreshHundler={onRefreshHundler} nameFilter={nameFilter}/>
      {/* <ActivityList name='' label={label} url={url} done={refresh} stateHundler={stateHundler} onRefreshHundler={onRefreshHundler} headers={headers}/> */}
      </div>  
      {/* <ModalClient modalState={modalState} inputs={inputsToUpdate} selectors={selectorsToUpdate} url={url} toUpdate={url+'/'+ toUpdateId }  onRefreshHundler={onRefreshHundler} stateHundler={stateHundler} name={language[language.lang].modals[label].updateDescription} title={language[language.lang].modals[label].updateTitle} /> */}
      <ModalPipeline 
        modalState={modalState} inputs={inputsToUpdate} client={client} stageType={stageType}
        selectors={selectorsToUpdate} url={urlFinal} urlConversationsProgress={urlConversationsProgress}
        toUpdate={url+'/'+ toUpdateId } id={toUpdateId} 
        onRefreshHundler={onRefreshHundler} stateHundler={stateHundler} name={language[language.lang].modals[label].updateDescription} title={language[language.lang].modals[label].updateTitle} />

    </main>

  </Layout>
  )
}

export default Pipeline